export default __webpack_public_path__ + "static/transfer-4156071659dfe00bfe49ceb6be61fb50.png";